import { apiAxiosCMS } from 'services/api';
import { BlogProps } from 'types/BlogProps';

export async function getBlogs(
	setIsLoad: React.Dispatch<React.SetStateAction<boolean>>,
	handleNotify: any
) {
	setIsLoad(true);
	const listBlogs: BlogProps[] = await apiAxiosCMS
		.get('/blog')
		.then((response) => {
			setIsLoad(false);
			return response?.data || [];
		})
		.catch(() => {
			handleNotify('Erro ao buscar o conteúdo', 'error');
			setIsLoad(false);
			return [];
		});

	return listBlogs;
}

export async function saveOrderReq(
	list: BlogProps[],
	handleNotify: any,
	showMessageResult = true
) {
	const newList = list.map((item, i) => ({
		id: item.id,
		position: i + 1
	}));

	await apiAxiosCMS
		.patch('/blog/sort', { items: newList })
		.then((response) => {
			if (showMessageResult) {
				handleNotify('Ordem da lista foi salva com sucesso', 'success');
			}
			return response?.data || [];
		})
		.catch(() => {
			handleNotify('Erro ao salvar odem da lista. Tente novamente', 'error');
			return [];
		});
}
